import RankProgress from "./RankProgress";

export default function RightRankingCard() {
    return (
        <div className="MuiPaper-root styles_headingRight__EaPSD MuiPaper-elevation1 MuiPaper-rounded">
            <div className="MuiGrid-root MuiGrid-container MuiGrid-item">
                <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-5">
                    <p className="MuiTypography-root styles_titleRanking__5Or_5 MuiTypography-body1">
                        Điểm xếp hạng
                    </p>
                </div>

                <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-content-xs-flex-end MuiGrid-grid-xs-7">
                    <p className="MuiTypography-root styles_datePoint__0p4Q2 MuiTypography-body1">
                        Tính từ 01/11/2025 - Hôm nay
                    </p>
                </div>
            </div>

            <RankProgress />

            <div
                className="MuiGrid-root styles_rankPoint__eH6Ky MuiGrid-item MuiGrid-grid-xs-12"
                style={{ marginTop: "16px" }}
            >
                <p style={{ margin: 0, color: "rgb(0, 0, 0)" }}>
                    Cần 80 điểm để thăng hạng
                    <span style={{ textTransform: "capitalize" }}> Vàng </span>
                </p>
            </div>

            <div
                className="MuiGrid-root styles_rankPoint__eH6Ky MuiGrid-item MuiGrid-grid-xs-12"
                style={{ marginTop: "16px" }}
            />
        </div>
    );
}
